<ng-select [(ngModel)]="selectedUsers"
           [items]="(users$ | async) ?? []"
           [typeahead]="usersSearchInput$"
           [loading]="usersLoading"
           [placeholder]="placeholder"
           [multiple]="multiple"
           [compareWith]="compareWith"
           [virtualScroll]="false"
           (search)="onSearchTermChange($event)"
           (clear)="resetCurrentSearch()"
           (open)="onDropdownOpen()"
           (close)="onDropdownClose()"
           bindLabel="label"
           class="select-users"
           data-identifier="uid-audit-reports-users">
    <ng-template ng-label-tmp let-item="item" >
        <div (mousedown)="$event.stopPropagation()" [ngClass]="{'span-label':multiple}">
            <span class="ng-value-label">{{ item | lastAndFirstName }}</span>
            <span class="close" (click)="onClear(item)" (mousedown)="$event.stopPropagation()" aria-hidden="true" *ngIf="multiple">×</span>
        </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
        <div>{{ item.label }}</div>
    </ng-template>
</ng-select>
